import * as tokens from '@audi/audi-ui-design-tokens';
export const colors = {
    form: {
        primary: tokens.COLOR_FORM_PRIMARY_LIGHT,
        secondary: tokens.COLOR_FORM_SECONDARY_LIGHT,
        tertiary: tokens.COLOR_FORM_TERTIARY_LIGHT,
        strong: tokens.COLOR_FORM_STRONG_LIGHT,
        error: tokens.COLOR_FORM_ERROR_LIGHT,
        muted: {
            primary: tokens.COLOR_FORM_MUTED_PRIMARY_LIGHT,
            secondary: tokens.COLOR_FORM_MUTED_SECONDARY_LIGHT,
            tertiary: tokens.COLOR_FORM_MUTED_TERTIARY_LIGHT,
        },
    },
    text: {
        primary: tokens.COLOR_TEXT_PRIMARY_LIGHT,
        secondary: tokens.COLOR_TEXT_SECONDARY_LIGHT,
        inactive: tokens.COLOR_TEXT_INACTIVE_LIGHT,
        error: tokens.COLOR_TEXT_ERROR_LIGHT,
    },
    ui: {
        accent: tokens.COLOR_BASE_BRAND_PROGRESSIVE_RED,
        disabled: tokens.COLOR_UI_DISABLED_LIGHT,
        divider: {
            primary: tokens.COLOR_UI_DIVIDER_PRIMARY_LIGHT,
        },
        error: tokens.COLOR_UI_ERROR_LIGHT,
        success: tokens.COLOR_UI_SUCCESS_LIGHT,
        hover: tokens.COLOR_UI_HOVER_LIGHT,
        primary: tokens.COLOR_UI_PRIMARY_LIGHT,
        primaryInverse: tokens.COLOR_UI_PRIMARY_INVERSE_LIGHT,
    },
    utility: {
        white: tokens.COLOR_UTILITY_WHITE_LIGHT,
        black: tokens.COLOR_UTILITY_BLACK_LIGHT,
        neutral: {
            0: tokens.COLOR_UTILITY_NEUTRAL_0_LIGHT,
            5: tokens.COLOR_UTILITY_NEUTRAL_5_LIGHT,
            10: tokens.COLOR_UTILITY_NEUTRAL_10_LIGHT,
            15: tokens.COLOR_UTILITY_NEUTRAL_15_LIGHT,
            20: tokens.COLOR_UTILITY_NEUTRAL_20_LIGHT,
            30: tokens.COLOR_UTILITY_NEUTRAL_30_LIGHT,
            40: tokens.COLOR_UTILITY_NEUTRAL_40_LIGHT,
            50: tokens.COLOR_UTILITY_NEUTRAL_50_LIGHT,
            60: tokens.COLOR_UTILITY_NEUTRAL_60_LIGHT,
            70: tokens.COLOR_UTILITY_NEUTRAL_70_LIGHT,
            80: tokens.COLOR_UTILITY_NEUTRAL_80_LIGHT,
            90: tokens.COLOR_UTILITY_NEUTRAL_90_LIGHT,
            100: tokens.COLOR_UTILITY_NEUTRAL_100_LIGHT,
        },
    },
    notification: {
        neutral: tokens.COLOR_NOTIFICATION_NEUTRAL_LIGHT,
        error: tokens.COLOR_NOTIFICATION_ERROR_LIGHT,
        warning: tokens.COLOR_NOTIFICATION_WARNING_LIGHT,
        success: tokens.COLOR_NOTIFICATION_SUCCESS_LIGHT,
    },
    option: {
        primary: tokens.COLOR_OPTION_PRIMARY_LIGHT,
        secondary: tokens.COLOR_OPTION_SECONDARY_LIGHT,
        tertiary: tokens.COLOR_OPTION_TERTIARY_LIGHT,
        disabled: {
            primary: tokens.COLOR_OPTION_DISABLED_PRIMARY_LIGHT,
            secondary: tokens.COLOR_OPTION_DISABLED_SECONDARY_LIGHT,
            tertiary: tokens.COLOR_OPTION_DISABLED_TERTIARY_LIGHT,
        },
    },
};
//# sourceMappingURL=audi-colors.js.map